import React, { useContext, useState } from 'react';

import './LabelsTable.css';
import B2BTable from '../../b2b-common/B2BTable';
import { LoginContext } from '../../../App';
import { callAPIWhileSettingState } from '../../b2b-common/helpers';
import { getKeyTranslations } from '../../../services/b2b-languages-apiService';

const LabelsTable = ({ labelsPagedData, onSelectLabel, pagesCount, currentPage, onPageChange, className }) => {

    const { loginData } = useContext(LoginContext);
    const [loadingRowId, setLoadingRowId] = useState(null);

    const headers = [
        { label: 'Locale', align: 'center' },
        { label: 'Key', align: 'left' },
        { label: 'Content', align: 'left' },
    ];

    const rows = labelsPagedData.content.map((label) => ({
        id: label.languageId,
        cells: [
            { content: `${label.locale}`, align: 'center' },
            { content: `${label.key}`, align: 'left' },
            { content: `${label.content}`, align: 'left' },
        ]
    }));

    const fetchAllKeyTranslations = async (id, key) => {
        try {
            const paramsArray = [
                key,
                loginData.accessToken
            ];
            setLoadingRowId(id);
            callAPIWhileSettingState(getKeyTranslations, paramsArray,
                null, onSelectLabel);
            setLoadingRowId(null);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSelectRow = (rowInTable => {
        fetchAllKeyTranslations(rowInTable.id, rowInTable.cells[1].content);
    })

    //console.log(rows);

    return <B2BTable
        pagesCount={pagesCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        headers={headers} rows={rows}
        onRowClick={handleSelectRow}
        rowLoading={loadingRowId}
        className={className} />;
}

LabelsTable.defaultProps = {
    labelsPagedData: { content: [] },
    onSelectUser: null,
    className: '',
};

export default LabelsTable;
